<form autocomplete="off" [formGroup]="testedPartyForm" (submit)="onSubmit()" id="testedPartyForm" class="adj-form">
  <app-adjustement-modal-template title="{{ titleText }}">
    <div body>
      <div class="row">
        <div class="col-lg-12 p-2 align-self-center">
          <span class="ey-float-label">
            <input
              type="text"
              class="form-control"
              id="testedPartyName"
              name="testedPartyName"
              formControlName="testedPartyName"
              maxlength="50"
              appLabelFloat
            />
            <label for="testedPartyName">Tested Party Name</label>
            <app-validation-errors [control]="testedPartyForm.controls['testedPartyName']"></app-validation-errors>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 p-2 align-self-center">
          <span class="ey-float-label">
            <select class="form-control form-select" id="currency" name="currency" formControlName="currency" [disabled]="readOnly" appLabelFloat>
              <option *ngFor="let type of currencies" [ngValue]="type">{{ type.currencyCode }}</option>
            </select>
            <label for="currency">Currency</label>
          </span>
          <app-validation-errors [control]="testedPartyForm.controls['currency']"></app-validation-errors>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 p-2 align-self-center">
          <span class="ey-float-label">
            <select
              class="form-control form-select"
              id="currencyUnits"
              name="currencyUnits"
              formControlName="currencyUnits"
              [disabled]="readOnly"
              appLabelFloat
            >
              <option *ngFor="let cu of currencyUnits" [ngValue]="cu.lookupId">{{ cu.displayText }}</option>
            </select>
            <label for="currencyUnits">Currency Units</label>
            <app-validation-errors [control]="testedPartyForm.controls['currencyUnits']"></app-validation-errors>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 d-flex p-2">
          <hr />
          <span class="flex-grow-1 ey-float-label ey-textarea-label m-0 p-0" title="Enter a reason">
            <textarea
              class="form-control"
              id="internalNotes"
              name="internalNotes"
              maxlength="512"
              minRows="2"
              minHeight="48"
              paddingHeight="32"
              [disabled]="readOnly"
              appLabelFloat
              appAutosize
              formControlName="internalNotes"
            ></textarea>
            <label for="internalNotes">Internal Notes</label>
          </span>
        </div>
      </div>
    </div>
    <div footer>
      <button type="button" class="btn btn-default m-2" (click)="close()">Cancel</button>
      <button type="button" type="submit" class="btn btn-primary m-2" [disabled]="readOnly || !testedPartyForm.valid">
        {{ saveButtonText }}
      </button>
    </div>
  </app-adjustement-modal-template>
</form>
